import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";

import { Button } from "@/components/Form";
import ResultGlass, { ResultType } from "@/components/ResultGlass";
import LocaleContext from "@/i18n";

type PollSummaryProps = {
  userVoteCount: number;
  totalVoteCount: number;
  showDetails: boolean;
  onCtaClick?: () => void;
  onLoad?: () => void;
};

export const PollSummary: React.FC<PollSummaryProps> = (
  props: PollSummaryProps
): React.JSX.Element => {
  const [showResult, setShowResult] = useState<boolean>(false);

  const localeContext = useContext(LocaleContext);

  const { onCtaClick, userVoteCount, totalVoteCount, showDetails, onLoad } =
    props;

  useEffect(() => {
    if (onLoad) {
      setTimeout(() => onLoad(), 4500);
    }
    setTimeout(() => setShowResult(true), 1500);
  }, []);

  return (
    <SummaryContent>
      {showResult && (
        <SummaryBox>
          <ResultGlass
            type={ResultType.percent}
            resultText={localeContext.translation.pollSummary.resultText}
            userVoteCount={userVoteCount}
            totalVoteCount={totalVoteCount}
            showDetails={showDetails}
          />
        </SummaryBox>
      )}
      {showResult && onCtaClick && (
        <Button onClick={onCtaClick}>
          {localeContext.translation.registerAgain}
        </Button>
      )}
    </SummaryContent>
  );
};

const SummaryContent = styled.div`
  min-height: 361px;
  width: 90%;
  margin: 0 auto;
`;

const SummaryBox = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px 0;
`;
